"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUserMeasurement = hasUserMeasurement;
exports.isCaptureHidden = isCaptureHidden;
exports.compositeURL = compositeURL;
exports.captureReferenceString = captureReferenceString;
exports.extractSubforms = extractSubforms;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var core_shared_3 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var DataGrid_1 = require("./components/DataGrid");
var ImageGrid_1 = require("./components/ImageGrid");
var SubForm_1 = require("./components/SubForm");
var DataExtractor_1 = require("./DataExtractor");
/**
 * Checks if a poles capture has any user measurements / annotations
 * NOTE: Insight generated measurements are ignored as we don't want them so show up in reports
 * @param pole The pole object.
 * @param captureId The ID of the capture.
 * @returns A boolean indicating whether the capture has user measurements / annotations
 */
function hasUserMeasurement(pole, captureId) {
    return pole.getDrawableState(captureId).hasUserMeasurements();
}
/**
 * Checks if a capture is marked as hidden
 * @param pole The pole object.
 * @param captureId -he ID of the capture.
 * @returns A boolean indicating whether the capture is marked as hidden
 */
function isCaptureHidden(pole, captureId) {
    return pole.getImageVisibilityState(captureId).hideForExport();
}
/**
 * Generates a composite URL for a given pole and capture file
 * @param pole The pole object.
 * @param capture The capture file object.
 * @returns The composite URL.
 */
function compositeURL(pole, capture) {
    var units = services_1.Services.UserSettings.units;
    return "".concat(window.location.origin, "/v1/collection/").concat(pole.id, "/").concat(pole.revision, "/").concat(capture.objectId, "_large_composite_").concat(units, ".jpeg");
}
/**
 * Generates an ImageReference string based on the provided pole and capture information.
 * @param pole The pole object.
 * @param capture The capture file JSON object.
 * @returns The generated ImageReference string
 */
function captureReferenceString(pole, capture) {
    return "".concat(pole.revision, "-").concat(capture.objectId);
}
/**
 * Extracts information from a sub form and returns an array of renderable SubForms.
 * @param subform The sub form to extract data from
 * @param imagesHolder The object to store image URL references
 * @returns An array of renderable SubForms.
 */
function extractSubforms(pole, subform, imagesHolder, columns) {
    if (columns === void 0) { columns = DataGrid_1.DEFAULT_COLUMN_AMOUNT; }
    var instanceArray = [];
    (0, lodash_1.forEach)(subform.instances, function (instance) {
        var subfieldsArray = [];
        var subformArray = [];
        var imageGrid = [];
        var truesizeGrid = [];
        instance.forEachField(function (subfield) {
            var _a;
            if (subfield.parent.instanceId === instance.instanceId) {
                switch (true) {
                    // Extract all the images and add them to their respective grids
                    case subfield instanceof core_shared_3.CollectionModelFieldImage:
                    case subfield instanceof core_shared_2.CollectionModelFieldTrueSize:
                        var captures = subfield.getCaptures();
                        var targetGrid = subfield instanceof core_shared_2.CollectionModelFieldTrueSize ? truesizeGrid : imageGrid;
                        if (captures.length > 0) {
                            var imageReferences_1 = [];
                            captures.forEach(function (capture) {
                                if (!isCaptureHidden(subform.collection, capture.objectId)) {
                                    var imageReferenceString = captureReferenceString(pole, capture);
                                    imagesHolder[imageReferenceString] = subfield instanceof core_shared_2.CollectionModelFieldTrueSize ? compositeURL(subform.collection, capture) : capture.medium.url;
                                    imageReferences_1.push({ reference: imageReferenceString });
                                }
                            });
                            if (imageReferences_1.length > 0) {
                                targetGrid.push(new ImageGrid_1.ImageGrid((_a = {}, _a[subfield.schema.displayName] = imageReferences_1, _a)));
                            }
                        }
                        break;
                    case subfield instanceof core_shared_1.CollectionModelFieldSubForm:
                        subformArray.push.apply(subformArray, extractSubforms(pole, subfield, imagesHolder, columns));
                        break;
                    default:
                        var extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(subfield);
                        if (extractedValue.value) {
                            subfieldsArray.push([extractedValue.title, extractedValue.value]);
                        }
                }
            }
        });
        instanceArray.push(new SubForm_1.SubForm(subform.schema.displayName, instance.title || instance.subtitle || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([new DataGrid_1.DataGrid(subfieldsArray, columns)], imageGrid, true), truesizeGrid, true), subformArray, true)));
    });
    return instanceArray;
}
//# sourceMappingURL=ReportHelpers.js.map